import * as React from 'react';
import Fab, { FabProps } from '@material-ui/core/Fab';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

const styles = (theme: Theme) =>
  createStyles({
    fab: {
      position: 'fixed',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
      zIndex: 1000
    }
  });

type OwnProps = {
  icon: JSX.Element;
  to?: string;
  label: string;
};

type Props = OwnProps &
  WithStyles<typeof styles> &
  Omit<FabProps, 'children'> &
  Omit<RouterLinkProps, 'innerRef' | 'to'>;

const FloatingActionButtonComponent: React.SFC<Props> = ({ to, icon, classes, label, className, ...rest }) => {
  const Link = React.useMemo(
    () =>
      React.forwardRef<any, Omit<RouterLinkProps, 'to'>>((linkProps, ref) =>
        to ? <RouterLink ref={ref} to={to} {...linkProps} /> : null
      ),
    [to]
  );

  const CustomFab = React.forwardRef<
    HTMLButtonElement,
    Omit<FabProps<'button', { component?: typeof Link }>, 'children'>
  >((props, ref) => (
    <Fab ref={ref} aria-label={label} color="secondary" className={`${classes.fab} ${className || ''}`} {...props}>
      {icon}
    </Fab>
  ));

  return <CustomFab component={to ? Link : undefined} {...rest} />;
};

export const FloatingActionButton = withStyles(styles)(FloatingActionButtonComponent);
